module.exports = __webpack_public_path__ + "static/media/last.f5c39fd0.svg";